import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { useDictionary } from "hooks";
import { COLUMN_HEADER_KEYS } from "globals/constants";
import { getProject } from "store/actions/project";
import FormHistoryView from "components/FormHistoryView";
import { projectSelectors } from "store/selectors";


const ProjectHistoryView = () => {
	const project = useSelector(projectSelectors.project);

	//const formAccesses = useFormAccesses(COLUMN_HEADER_KEYS.PROPOSAL, proposal.proposalId);

	const dictionary = useDictionary("projects.history"); //TODO: change to project

	const updateProjectSelection = project => {
		const selections = new Map();
		const projectFeedItem = {
			id: project.id,
			projectId: project.projectId
		};
		selections.set(project.id, projectFeedItem);

		return selections;
	};

	const refreshProject = useCallback(() => {
		getProject(project.projectId, { isRefresh: true });
	}, [ project ]);

	return (
		<FormHistoryView
			instance={project}
			refreshInstance={refreshProject}
			dictionary={dictionary}
			updateInstanceSelection={updateProjectSelection}
			canReadNotes={true /*TODO: where do we get this permission from?*/}
			canAssign={false /*TODO: where do we get this permission from?*/}
			adminRole={"" /*TODO: project doesnt have admin team*/}
			formType={COLUMN_HEADER_KEYS.PROJECT}
			formIdKey="projectId"
		/>
	);
};

export default ProjectHistoryView;
